import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../services/api.service';
import { TableModule } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-master-client-list',
  standalone: true,
  imports: [CommonModule, TableModule, ToastModule],
  providers: [MessageService],
  templateUrl: './master-client-list.component.html',
  styles: [`
    .master-card {
      background: white;
      border-top: 4px solid #1e293b;
    }
  `]
})
export class MasterClientListComponent implements OnInit {
  clients: any[] = [];
  loading: boolean = false;

  constructor(
    private apiService: ApiService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadClients();
  }

  loadClients(): void {
    this.loading = true;
    this.apiService.getClients().subscribe({
      next: (response) => {
        this.clients = response && response.data ? response.data : [];
        this.loading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load clients'
        });
        this.loading = false;
      }
    });
  }
}
